

































import { Component, Vue } from "vue-property-decorator";
import { useExplainListType } from "@/api/system";

@Component
export default class extends Vue {
  dataObj = {
    getListUrl: "/blackcat/story/line/user/list",
    directUrl: "userStoryDetail",
    onLineType: "userOnline",
  };
  list = [];
  activeName = "";
  created() {
    this.getUseExplainList();
  }
  async getUseExplainList() {
    const res = await useExplainListType();
    if (res?.data?.length) {
      this.list = res.data;
      this.activeName = res.data[0].manualType;
    }
  }
  toDetail(url: string) {
    if (!url) {
      this.$message({
        type: "error",
        message: "请先上传storyLine链接",
      });
      return;
    }
    this.$router.push({
      path: "/useExplainDetail",
      query: {
        url: url,
        name: "使用说明详情",
        path: this.$route.path,
      },
    });
  }
}
